<app-loading-indicator />
<router-outlet />
